var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchiveFill = function SvgArchiveFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.9 10.2h16.2v9.004c0 .495-.4.896-.894.896H4.794a.895.895 0 0 1-.894-.896zM9.3 12v1.8h5.4V12zM3 4.8c0-.496.41-.9.893-.9h16.214c.493 0 .893.4.893.9v3.6H3z"
  })));
};
export default SvgArchiveFill;